import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { CodeClub } from 'app/shared/models/class/club/club';
import { ClubService } from 'app/shared/services/club/club.service';

export interface DialogData {
  url: string;
  title: string;
}

@Component({
  selector: 'app-open-dialog-choice-club-admin',
  templateUrl: './open-dialog-choice-club-admin.component.html',
  styleUrls: ['./open-dialog-choice-club-admin.component.scss']
})
export class OpenDialogChoiceClubAdminComponent implements OnInit {

  choiceClubForm: UntypedFormGroup;
  clubs: CodeClub[];
  title: string;

  constructor(
    public dialogRef: MatDialogRef<OpenDialogChoiceClubAdminComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private formBuilder: UntypedFormBuilder,
    private clubService: ClubService,
    private router: Router,
  ) { }

  ngOnInit(): void {
    this.initForm();
    this.initComponent();
  }

  onSubmit(): void {
    this.router.navigate([this.data.url], { queryParams: { clubCode: this.f.club.value } });
    this.dialogRef.close();
  }

  private getClubs(): void {
    this.clubService.getClubs().subscribe({
      next: clubs => this.clubs = clubs.sort((a, b) => a.code.localeCompare(b.code))
    });
  }

  get f() {
    return this.choiceClubForm.controls;
  }
  private initComponent(): void {
    this.getClubs();

    const title = {
      counter: 'Choisir le guichet d\'un club',
      planing: 'Choisir un club pour la planification',
      praticeplace: 'Choisir un club pour gérer ses lieux de pratique',
      discount: 'Choisir un club pour gérer ses codes promo',
      resource: 'Choisir un club pour gérer ses ressources',
      usedressources: 'Choisir un club lister ses ressources utilisées',
      payments: 'Choisir un club pour gérer ses paiements'
    };

    this.title = title[this.data.title];
  }

  private initForm(): void {
    this.choiceClubForm = this.formBuilder.group({
      club: ['', Validators.required]
    });
  }

}
